import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { StepDefinition } from "../../core/flows/StepDefinition";
import { checkoutStepDefinition } from "../CheckoutPage/CheckoutStartup";
import { MultiBookingInitStepDeclaration } from "./Steps/MultiBookingInitStep";

export const MultiBookingStartupFlow = new FlowDefinition("MultiBookingFlow");

MultiBookingStartupFlow.addStep(MultiBookingInitStepDeclaration);
MultiBookingStartupFlow.addStep(checkoutStepDefinition);

MultiBookingStartupFlow.addLink("MultiBookingInit_Step", "CheckoutFlow")

MultiBookingStartupFlow.setStartStep("MultiBookingInit_Step");

export const MultiBookingStartupStepDefinition = new StepDefinition({
    stepName: "MultiBookingFlow",
    stepFlow: MultiBookingStartupFlow,
    contextIsolation: false
})
